// extracted by mini-css-extract-plugin
module.exports = {"menuWrapper":"MonitorMenu-menuWrapper-irtCZm"};